import EventEmitter from "./utils/EventEmitter";

export default class TextEllipsis extends EventEmitter {
    constructor(element) {
        super();

        this.el = element
        this.wrapper = this.el.querySelector('.ellipsis-wrapper')
        this.btn = this.el.querySelector('.show-more')
        this.open = false

        const isLineClampAvailable = () => {
            const test = document.createElement('div')
            test.style.display = 'none'
            test.style.webkitLineClamp = '2'
            return test.style.webkitLineClamp === '2'
        }

        if (isLineClampAvailable()) {
            this.maskText()
            this.events()
        }
    }

    events() {
        this.btn.addEventListener('click', () => {
            if (!this.open) {
                this.showMore()
            } else {
                this.maskText()
            }
        })
    }

    showMore() {
        this.open = true
        this.wrapper.style.webkitLineClamp = 'unset'
        this.btn.innerHTML = `${this.btn.dataset.less}`

        // Force reflow (mobile issue with webkitLineClamp)
        this.wrapper.style.display = 'none'
        this.wrapper.offsetHeight
        this.wrapper.style.display = 'block'
    }

    maskText() {
        this.open = false
        this.wrapper.style.webkitLineClamp = `${this.el.dataset.lines}`
        this.btn.innerHTML = `${this.btn.dataset.more}`

        // Force reflow (mobile issue with webkitLineClamp)
        this.wrapper.style.display = 'none'
        this.wrapper.offsetHeight
        this.wrapper.style.display = '-webkit-box'
    }
}
